import { Resizable } from 're-resizable';
import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { FileContext } from '../../../context/FileContext';

const OuterContainer = styled.div`
  padding: 2px;
  border: 4px solid transparent !important;
  border-radius: 4px !important;

  &.active {
    border: 4px solid rgba(0, 115, 234, 0.4) !important;
    border-radius: 4px !important;
  }

  &.hover-active:hover {
    border: 4px solid rgba(0, 115, 234, 0.4) !important;
    border-radius: 4px !important;
  }
`;

const SignDateOuterContainer = styled.div`
  border: 1px solid #c5c7d0 !important;
  border-radius: 4px;
  background: white;
`;

const SignDatePreviewContainer = styled.div`
  font-size: ${({ fontSize }) => fontSize + 'px'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  color: #676879;
`;

const SignDateEditOverlayChip = ({ item, setIsResizing }) => {
  // height of container for text box on initialization
  const defaultHeight = 11;
  const defaultWidth = 80;
  const defaultFontSize = 11;

  const {
    addedFormFields,
    updateFormFields,
    currentSelectedItem,
    draggableFieldsData,
  } = useContext(FileContext);

  const [fontSize, setFontSize] = useState(item.fontSize || defaultFontSize);

  useEffect(() => {
    if (!item?.width) item.width = defaultWidth;
    if (!item?.height) item.height = defaultHeight;
  }, []);

  const calculateFontSize = (addedHeight, prevHeight) => {
    const height = addedHeight + prevHeight;
    return height;
  };

  const handleResizeStart = (_e, _dir) => {
    setIsResizing(true);
  };

  const handleResizeEnd = (item) => (_e, _dir, _ref, d) => {
    setIsResizing(false);

    item.fontSize = calculateFontSize(d.height, item?.height);
    item.width += d.width;
    item.height += d.height;

    setFontSize(item.fontSize);

    addedFormFields[currentSelectedItem.current] = item;
    draggableFieldsData[item.itemId] = {
      height: item.height,
      width: item.width,
      fontSize: item.fontSize,
    };
    updateFormFields([...addedFormFields]);
  };

  const handleResize = (e, _dir, _ref, d) => {
    setFontSize(calculateFontSize(d.height, item.height));
  };

  return (
    <>
      <OuterContainer className={item.isActive ? 'active' : 'hover-active'}>
        <SignDateOuterContainer>
          <Resizable
            size={{
              height: item?.height || defaultHeight,
              width: item?.width || defaultWidth,
            }}
            lockAspectRatio={true}
            enable={{
              top: false,
              right: item?.isActive,
              bottom: item?.isActive,
              left: false,
              topRight: false,
              bottomRight: item?.isActive,
              bottomLeft: false,
              topLeft: false,
            }}
            className={'resizeable'}
            onResizeStart={handleResizeStart}
            onResizeStop={handleResizeEnd(item)}
            onResize={handleResize}
          >
            <SignDatePreviewContainer fontSize={fontSize}>
              {item.dateFormat?.format}
            </SignDatePreviewContainer>
          </Resizable>
        </SignDateOuterContainer>
      </OuterContainer>
    </>
  );
};

export default SignDateEditOverlayChip;
